import { Appointment, Consumer } from 'lib/amwell/sdk/types';
import BaseService from './BaseService';
import AwsdkError from '../errors/AwsdkError';

export default class AppointmentService extends BaseService {
  async getAppointments(consumer: Consumer): Promise<Appointment[]> {
    const key = this.getAppointments.name;

    try {
      return await this.sdk.appointmentService.getAppointments(consumer);
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }

  async getAppointment(appointment: Appointment): Promise<Appointment> {
    const key = this.getAppointment.name;

    try {
      return await this.sdk.appointmentService.getAppointment(appointment);
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }
}
